import { motion } from "framer-motion";

const STEPS = [
  { n: "01", t: "PICK A TIME", b: "Choose a time that works." },
  {
    n: "02",
    t: "SHARE THE CONTEXT",
    b: "Tell us where your lead flow or follow-up is getting stuck.",
  },
  {
    n: "03",
    t: "LEAVE WITH A CLEARER MOVE",
    b: "Have a focused strategy conversation around the most practical next step.",
  },
];

export default function ReplayProcess() {
  return (
    <section
      className="relative py-28 md:py-40 border-t wam-hairline"
      data-testid="replay-process"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8 }}
          className="mb-10 flex items-center gap-4"
        >
          <span className="font-mono text-[11px] tracking-[0.3em] text-[#F0ECE4]/40">
            [004] —
          </span>
          <span className="font-mono text-[11px] tracking-[0.3em] text-[#C9A84C]">
            AFTER YOU BOOK
          </span>
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9 }}
          className="font-display max-w-[1000px] mb-16"
          style={{ fontSize: "clamp(30px, 4vw, 60px)", lineHeight: 0.98, letterSpacing: "-0.03em" }}
        >
          What happens next.
        </motion.h2>

        {/* Timeline */}
        <div className="relative">
          <div className="absolute left-0 right-0 top-[42px] hidden md:block h-px bg-[#C9A84C]/25" />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6">
            {STEPS.map((s, i) => (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.7, delay: i * 0.12 }}
                className="relative"
                data-testid={`replay-step-${i}`}
              >
                <div className="relative flex h-[84px] w-[84px] items-center justify-center border wam-hairline-strong bg-[#070709]">
                  <span className="font-mono text-[11px] tracking-[0.2em] text-[#C9A84C]">
                    {s.n}
                  </span>
                  <span className="absolute -top-[6px] -left-[6px] h-[12px] w-[12px] border-t border-l border-[#C9A84C]" />
                  <span className="absolute -bottom-[6px] -right-[6px] h-[12px] w-[12px] border-b border-r border-[#C9A84C]" />
                </div>
                <div className="mt-6 font-display text-[17px] md:text-[20px] tracking-[-0.02em]">
                  {s.t}
                </div>
                <p className="mt-2 max-w-[300px] font-body text-[14px] leading-[1.65] text-[#F0ECE4]/60">
                  {s.b}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
